
<template>
  <div>
    <v-btn v-if="can_create" class="my-2" text color="success" @click="createNewDeal()"><v-icon
        left>mdi-plus</v-icon>Nova negociação</v-btn>

    <v-alert v-if="loading" type="info" :value="true" style="border-radius: 12px;">
      Carregando negociações
      <v-progress-linear color="white" :indeterminate="true"></v-progress-linear>
    </v-alert>
    <v-card style="border-radius:1px" text v-if="all_deals.length">
      <v-card-title primary-title>
        <div class="title mb-0">Histórico de negociações</div>
      </v-card-title>
      <v-card-text>
        <v-data-table :headers="headers" :items="all_deals" mobile-breakpoint="1" >
          <template v-slot:items="props">
            <tr @click="dealDetails(props.item.id)" style="cursor: pointer">
              <td>
                <v-tooltip top color="black">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small :color="status_icons[props.item.status].color">{{
                      status_icons[props.item.status].icon
                    }}</v-icon>
                  </template>
                  {{ status_icons[props.item.status].text }}
                </v-tooltip>
              </td>
              <td> {{ props.item.total_deal_bags }} </td>
              <td>
                <v-tooltip top color="black">
                  <template v-slot:activator="{ on }">
                    <v-chip v-on="on" outlined small color="grey darken-2">
                      <v-avatar>
                        {{ props.item.deal_items.length }}
                      </v-avatar>
                      itens
                    </v-chip>
                  </template>
                  {{ props.item.deal_item_names }}
                </v-tooltip>
              </td>
              <td> {{ props.item.total_deal_sell.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}
              </td>
              <td> {{
                props.item.total_deal_other_sell.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
              }}
              </td>
              <td> {{ new Date(props.item.created_at.substring(0, 10) + "T12:00:00").toLocaleDateString('pt-BR') }}
              </td>
              <td> {{ props.item.payment }} </td>

            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="deal_details.dialog" v-if="deal_details.dialog" scrollable max-width="500px"
      transition="dialog-transition">
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="title mb-0">Detalhes da negociação</div>
        </v-card-title>
        <v-card-text>
          <v-alert v-if="!deal_details.deal" type="info" :value="true" style="border-radius: 8px;">
            Carregando negociação...
            <v-progress-linear color="white" :indeterminate="true"></v-progress-linear>
          </v-alert>
          <show-deal v-if="deal_details.deal" :deal="deal_details.deal"></show-deal>
        </v-card-text>
      </v-card>
    </v-dialog>



    <v-dialog v-model="dialog_new_deal" v-if="dialog_new_deal" persistent scrollable max-width="600px"
      transition="dialog-transition">
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="title mb-0">Nova negociação</div>
        </v-card-title>
        <v-card-text>
          <v-col cols='12'>
            <main-data :deal="new_deal"></main-data>
          </v-col>


          <v-col cols='12'>
            <list-item :items="new_deal.deal_items_attributes"></list-item>
          </v-col>
        </v-card-text>
        <v-card-actions class="justify-end">
          <f-btn cancel @click="dialog_new_deal = false"></f-btn>
          <f-btn save alt_text="criar" alt_icon="mdi-check" @click="submitNewDeal()"></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-btn :disabled="!has_hist || all_deals.length > 0" text small style="border-radius: 7px;" color="primary"
      @click="getDeals()" rounded><v-icon small left>mdi-plus</v-icon>Ver histórico de negociações</v-btn>

  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index';

export default {
  components: {
    ShowDeal: () => import('./showDeal.vue'),
    MainData: () => import('./mainData.vue'),
    ListItem: () => import('./listItems.vue'),
  },
  data() {
    return {
      key: null,
      loading: false,
      all_deals: [],
      deal_details: {
        dialog: false,
        deal: null,
      },
      dialog_new_deal: false,
      new_deal: {
        status: 'open',
        payment_option_id: null,
        payment_time_id: null,
        comment: null,
        dealable_id: null,
        dealable_type: null,
        deal_items_attributes: [

        ]
      },
      headers: [
        { text: 'Status', value: 'status', },
        { text: 'Total de sacos', value: 'total_deal_bags', },
        { text: 'Itens', value: 'deal_item_names', },
        { text: 'Total negociado', value: 'total_deal_sell', },
        { text: 'Total concorrente', value: 'total_deal_other_sell', },
        { text: 'Criado em', value: 'created_at', },
        { text: 'Pagamento em', value: 'payment', },
        // {text: 'Ação', value: 'action',},
      ],
      status_icons: {
        won: {
          icon: 'mdi-thumb-up',
          color: 'success',
          text: 'Venceu'
        },
        lost: {
          icon: 'mdi-thumb-down',
          color: 'grey',
          text: 'Perdeu'
        }
      }
    }
  },
  methods: {
    getDeals() {
      if (this.oneClient) {
        this.loading = true
        Api.Deal.indexByModel('clients', this.oneClient.id).then(r => r.data).then(deal => {
          this.all_deals = deal.data.map(d => d.attributes).map(o => {
            return {
              ...o,
              payment: `${o.payment_option.description} - ${o.payment_time.description}`,
              deal_item_names: o.deal_items.length ? o.deal_items.map(o => o.brand_product_name).join(', ') : null,
              total_deal_bags: o.deal_items.length ? o.deal_items.reduce((a, b) => a + b.total_bags, 0) : null,
              total_deal_sell: o.deal_items.length ? o.deal_items.reduce((a, b) => a + (b.total_bags * b.sell_price), 0) : 0,
              total_deal_other_sell: o.deal_items.length ? o.deal_items.reduce((a, b) => a + (b.total_bags * b.other_sell_price), 0) : 0,
            }
          })
          this.loading = false
        }).catch(err => {
          console.error(err);
        })
      }
    },
    dealDetails(id) {
      // console.log({id});
      this.deal_details.dialog = true
      Api.Deal.show(id).then(r => r.data).then(deal => {
        setInterval(() => {
          this.deal_details.deal = {
            ...deal.data.attributes,
          }
        }, 1200);
      }).catch(err => {
        console.error(err);
      })
    },
    createNewDeal() {
      this.new_deal.dealable_id = this.$route.params.id
      this.new_deal.dealable_type = this.$route.path.includes('prosp') ? 'Prospect' : this.$route.path.includes('cli') ? 'Client' : null
      this.dialog_new_deal = true
    },
    submitNewDeal() {
      this.createDeal(this.new_deal).then(d => {
        this.oneClient.last_deal = { ...d.data.attributes }
        this.dialog_new_deal = false
      })
    },
    ...mapActions({
      createDeal: 'Deal/create'
    })
  },
  computed: {
    can_create() {
      return !this.oneClient.last_deal && !this.oneClient.client_id
    },
    has_hist() {
      return this.oneClient.last_deal ? this.oneClient.deal_ids.filter(d => d != this.oneClient.last_deal.id).length > 0 : this.oneClient.deal_ids.length > 0
    },
    ...mapState({
      oneClient: state => state.Client.oneClient.data.attributes,
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    'deal_details.dialog'(nv, ov) {
      if (nv) {
      } else if (nv == false) {
        this.deal_details.deal = null
      }
    },
    dialog_new_deal(nv, ov) {
      if (nv) {

      } else if (nv == false) {
        this.new_deal = {
          payment_option_id: null,
          payment_time_id: null,
          comment: null,
          dealable_id: null,
          dealable_type: null,
          deal_items_attributes: [

          ]
        }
      }
    }
  },
}
</script>

<style scoped>

</style>